import sessionService from '_services/common/sessionService';

export default function moduleMiddleware(module) {
  return (to, from, next) => {
    const user = sessionService.getLocalData('_user');

    if (user.modules.some(item => item.slug === module)) {
      next();
    } else {
      next('/admin/overview');
    }
  };
}
